import {
  clearConnectorList,
  getConnectorListFail,
  getConnectorListStarted,
  getConnectorListSuccess
} from '../../../reducer/connectors/ConnectorListReducer';
import { getConnectorList } from '../../actionType/connectors/ConnectorListTypes';
import {
  ClearGetConnectorList,
  GetConnectorListFailure,
  GetConnectorListFailurePayload,
  GetConnectorListRequest,
  GetConnectorListStarted,
  GetConnectorListSuccess,
  GetConnectorListSuccessPayload
} from '../../types/connectors/GetConnectorListTypes';

export const getConnectorListRequest = ():
  GetConnectorListRequest => ({
    type: getConnectorList.FETCH_CONNECTOR_LIST_REQUEST
  });

/**
* get metric summary started saga action
* @returns get metric summary action
*/
export const getConnectorListStart = (): GetConnectorListStarted => ({
  type: getConnectorListStarted.type
});

/**
* Get metric summary success saga action
* @param payload :Metric data
* @returns success action
*/
export const getConnectorListSuccessful = (
  payload: GetConnectorListSuccessPayload
): GetConnectorListSuccess => ({
  type: getConnectorListSuccess.type,
  payload
});

/**
* get metric Failed saga action
* @param payload : error message
* @returns Failure saga action
*/
export const getConnectorListFailure = (
  payload: GetConnectorListFailurePayload
): GetConnectorListFailure => ({
  type: getConnectorListFail.type,
  payload
});

/**
* Clear metrics saga action
* @param payload : error message
* @returns Failure saga action
*/
export const clearGetConnectorList = (): ClearGetConnectorList => ({
  type: clearConnectorList.type
});
